<script lang="ts">
	import {uqn} from './stores.js';
	// import Fraction from './functions/fractionClass';
	import check from './check_random/check';
	import Textfield, {Input, Textarea} from '@smui/textfield';
	import Button, {Label, Icon} from '@smui/button';
	import Dialog, {Title, Content, Actions} from '@smui/dialog';
	import Slider from '@smui/slider';
	import FormField from '@smui/form-field';
	import Katex from './Katex.svelte';
	// import Radio from '@smui/radio';
	// import getRandomInt from './functions/getRandomInt';

	let uqnInput: number;
	$: uqnInput = $uqn;
	let simpleDialog;

	let changeDummy, changeDummy2;
	// initialize
	let n = Number($uqn.toString()[0]);
	let m = Number($uqn.toString()[1]);
	let nKatex: string, mKatex:string;

	$: changeDummy = updateFromUQN($uqn);
	$: changeDummy2 = updateFromSliders(n,m)

	function updateFromUQN(u:number){
		n = Number(u.toString()[0]);
		m = Number(u.toString()[1]);
		nKatex = "n="+n.toString();
		mKatex = "m="+m.toString();
	}

	function updateFromSliders(n1:number,m1:number){
		n = n1; m=m1;
		nKatex = "n="+n1.toString();
		mKatex = "m="+m1.toString();
		uqnInput = n1*10+m1;
		uqn.set(uqnInput);
	}

	function uqnClick(){
		if (check(uqnInput)){
			uqn.set(uqnInput);
		} else{
			simpleDialog.open();
		}
	}	
</script>

<h2>Options</h2>
<hr>
<h3>UQN</h3>
<p>
	Retrieve a question by keying in a 2-digit UQN:
</p>
<Textfield class="shaped-outlined" variant="outlined" bind:value={uqnInput} label="UQN" type="number"/>
<Button on:click={uqnClick} variant="unelevated" class="button-shaped-round">
	<Label>Generate question</Label>
</Button>
<hr>
<h3>
	Question construction tools
</h3>
<p> 
	In this question, we will be rearranging <Katex math="n"/> married couples and <Katex math="m"/> pairs of single people.
</p>
<p>
	Use the sliders belows to choose different options to craft your own unique question.
</p>
<hr>
<div>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={n} min={3} max={6} step={1} style="width:80%" discrete displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={nKatex}/></span>
	</FormField>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={m} min={0} max={6-n} step={1} style="width:80%" discrete displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={mKatex}/></span>
	</FormField>
</div>

<Dialog bind:this={simpleDialog}>
	<!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
	<Title>Invalid UQN</Title>
	<Content>
		You have keyed an invalid UQN. Please try again.
	</Content>
	<Actions>
		<Button>
			<Label>OK</Label>
		</Button>
	</Actions>
</Dialog>
<hr>